import apiClient from './apiService';

class MermaidValidationService {
  constructor() {
    if (MermaidValidationService.instance) {
      return MermaidValidationService.instance;
    }
    MermaidValidationService.instance = this;
  }

  async validateUserInMermaid(ine) {
    try {
      const response = await apiClient.get(`/promoters/validate/${ine}`);
      return response.data;
    } catch (error) {
      console.error(`Error validating user with INE ${ine}:`, error);
      throw error;
    }
  }

  static getInstance() {
    if (!MermaidValidationService.instance) {
      MermaidValidationService.instance = new MermaidValidationService();
    }
    return MermaidValidationService.instance;
  }
}

export default MermaidValidationService.getInstance();
